export default [
  {
    role: 'user',
    priority: 1
  },
  {
    role: 'admin',
    priority: 2
  }
]	